import { z } from 'zod';

export const submodelSchema = z.object({
  id: z.number(),
});
